export default {
  title: 'Procesamiento de mensajes'
}
